'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var CloseButton = require('../CloseButton/CloseButton.js');
var utils = require('@chakra-ui/utils');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["onClick", "className"];
/**
 * ModalCloseButton is used closes the modal.
 *
 * You don't need to pass the `onClick` to it, it reads the
 * `onClose` action from the modal context.
 */
var ModalCloseButton = react.forwardRef(function (props, ref) {
  var onClick = props.onClick,
    className = props.className,
    rest = _objectWithoutProperties__default["default"](props, _excluded);
  var _useModalContext = react.useModalContext(),
    onClose = _useModalContext.onClose;
  var _className = utils.cx('chakra-modal__close-btn', className);
  var styles = react.useModalStyles();
  return /*#__PURE__*/React__default["default"].createElement(CloseButton.CloseButton, _extends__default["default"]({
    ref: ref,
    __css: styles.closeButton,
    className: _className,
    onClick: utils.callAllHandlers(onClick, function (event) {
      event.stopPropagation();
      onClose();
    })
  }, rest));
});
ModalCloseButton.displayName = 'ModalCloseButton';
exports.ModalCloseButton = ModalCloseButton;